// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emailStyle_logingriditem__9hylf {
    padding-bottom: 20px;
  }
  .emailStyle_forgotcontainer__W6M2x {
    background-color: #f0f2f5;
    width: 100%;
    border-radius: 33px;
    height: 59px;
    justify-content: space-around;
    align-items: center;
    display: flex;
  }
  .emailStyle_container__ZA98P {
    display: flex;
    flex-direction: row;
    width: 100%;
  }
  .emailStyle_emailmobilecontainer__V-HPn {
    justify-content: flex-end;
    display: inline-block;
    width: 60%;
    margin-top: 20px;
  }
  .emailStyle_forgotcontent__WgPc- {
    /* max-width: 450px;
    margin-left: 30%; */
    display: flex;
    flex-direction: row;
    /* width: 100%; */
    margin-top: 30px;
    justify-content: space-around;
  }
  .emailStyle_textinput__bIOND {
    width: 360px;
    height: 54px;
   
    
    background: #FAFAFB;
    border: 1px solid #ACACAC;
    border-radius: 5px;
  }
  .emailStyle_idpassword__Ro\\+1T {
    font-family: "Inter";
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
  }
  .emailStyle_btn1__9kdeD {
    color: #006644;
    border: 0;
  }
  .emailStyle_resheader__E4wn5 {
    /* position: absolute; */
    /* width: 233px;
    height: 36px;
    left: 787px;
    top: 162px; */
    width: 333px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
    /* line-height: 36px; */
    text-transform: capitalize;
  
    color: #001a11;
  }
  .emailStyle_accountActivationHeader__HRoNn{
    /* position: absolute; */
    /* width: 622px; */
    height: 36px;
    left: 372px;
    top: 129px;
    
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
    line-height: 36px;
    text-align: center;
    text-transform: capitalize;
    
    color: #001A11;
  }
  .emailStyle_accountActivationBody__nEVxh{
    /* position: absolute; */
/* width: 752px; */
height: 27px;
left: 307px;
top: 185px;

font-family: 'Inter';
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 27px;
/* identical to box height, or 169% */

text-align: center;

color: #001A11;


  }
  .emailStyle_AccountActivationImg__83DP6{
    /* position: absolute; */
width: 360px;
height: 266px;
left: 503px;
top: 306px;
  }

  .emailStyle_AccountActivationButton__jy9hX{
    display: flex;
flex-direction: row;
align-items: center;
padding: 13px 10px;
gap: 8px;

position: absolute;
width: 147px;
height: 40px;
top: 437px;

background: #009966;
border-radius: 5px;
  }`, "",{"version":3,"sources":["webpack://./src/components/styles/emailStyle.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;IAC7B,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;IACV,gBAAgB;EAClB;EACA;IACE;uBACmB;IACnB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;EAC/B;EACA;IACE,YAAY;IACZ,YAAY;;;IAGZ,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,cAAc;IACd,SAAS;EACX;EACA;IACE,wBAAwB;IACxB;;;iBAGa;IACb,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,0BAA0B;;IAE1B,cAAc;EAChB;EACA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,UAAU;;IAEV,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;;IAE1B,cAAc;EAChB;EACA;IACE,wBAAwB;AAC5B,kBAAkB;AAClB,YAAY;AACZ,WAAW;AACX,UAAU;;AAEV,oBAAoB;AACpB,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,qCAAqC;;AAErC,kBAAkB;;AAElB,cAAc;;;EAGZ;EACA;IACE,wBAAwB;AAC5B,YAAY;AACZ,aAAa;AACb,WAAW;AACX,UAAU;EACR;;EAEA;IACE,aAAa;AACjB,mBAAmB;AACnB,mBAAmB;AACnB,kBAAkB;AAClB,QAAQ;;AAER,kBAAkB;AAClB,YAAY;AACZ,YAAY;AACZ,UAAU;;AAEV,mBAAmB;AACnB,kBAAkB;EAChB","sourcesContent":[".logingriditem {\n    padding-bottom: 20px;\n  }\n  .forgotcontainer {\n    background-color: #f0f2f5;\n    width: 100%;\n    border-radius: 33px;\n    height: 59px;\n    justify-content: space-around;\n    align-items: center;\n    display: flex;\n  }\n  .container {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n  }\n  .emailmobilecontainer {\n    justify-content: flex-end;\n    display: inline-block;\n    width: 60%;\n    margin-top: 20px;\n  }\n  .forgotcontent {\n    /* max-width: 450px;\n    margin-left: 30%; */\n    display: flex;\n    flex-direction: row;\n    /* width: 100%; */\n    margin-top: 30px;\n    justify-content: space-around;\n  }\n  .textinput {\n    width: 360px;\n    height: 54px;\n   \n    \n    background: #FAFAFB;\n    border: 1px solid #ACACAC;\n    border-radius: 5px;\n  }\n  .idpassword {\n    font-family: \"Inter\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 30px;\n  }\n  .btn1 {\n    color: #006644;\n    border: 0;\n  }\n  .resheader {\n    /* position: absolute; */\n    /* width: 233px;\n    height: 36px;\n    left: 787px;\n    top: 162px; */\n    width: 333px;\n    font-family: \"Inter\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 30px;\n    /* line-height: 36px; */\n    text-transform: capitalize;\n  \n    color: #001a11;\n  }\n  .accountActivationHeader{\n    /* position: absolute; */\n    /* width: 622px; */\n    height: 36px;\n    left: 372px;\n    top: 129px;\n    \n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 30px;\n    line-height: 36px;\n    text-align: center;\n    text-transform: capitalize;\n    \n    color: #001A11;\n  }\n  .accountActivationBody{\n    /* position: absolute; */\n/* width: 752px; */\nheight: 27px;\nleft: 307px;\ntop: 185px;\n\nfont-family: 'Inter';\nfont-style: normal;\nfont-weight: 400;\nfont-size: 16px;\nline-height: 27px;\n/* identical to box height, or 169% */\n\ntext-align: center;\n\ncolor: #001A11;\n\n\n  }\n  .AccountActivationImg{\n    /* position: absolute; */\nwidth: 360px;\nheight: 266px;\nleft: 503px;\ntop: 306px;\n  }\n\n  .AccountActivationButton{\n    display: flex;\nflex-direction: row;\nalign-items: center;\npadding: 13px 10px;\ngap: 8px;\n\nposition: absolute;\nwidth: 147px;\nheight: 40px;\ntop: 437px;\n\nbackground: #009966;\nborder-radius: 5px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logingriditem": `emailStyle_logingriditem__9hylf`,
	"forgotcontainer": `emailStyle_forgotcontainer__W6M2x`,
	"container": `emailStyle_container__ZA98P`,
	"emailmobilecontainer": `emailStyle_emailmobilecontainer__V-HPn`,
	"forgotcontent": `emailStyle_forgotcontent__WgPc-`,
	"textinput": `emailStyle_textinput__bIOND`,
	"idpassword": `emailStyle_idpassword__Ro+1T`,
	"btn1": `emailStyle_btn1__9kdeD`,
	"resheader": `emailStyle_resheader__E4wn5`,
	"accountActivationHeader": `emailStyle_accountActivationHeader__HRoNn`,
	"accountActivationBody": `emailStyle_accountActivationBody__nEVxh`,
	"AccountActivationImg": `emailStyle_AccountActivationImg__83DP6`,
	"AccountActivationButton": `emailStyle_AccountActivationButton__jy9hX`
};
export default ___CSS_LOADER_EXPORT___;
